import { render, staticRenderFns } from "./MediumMediaSetting.vue?vue&type=template&id=69a79d1c&"
import script from "./MediumMediaSetting.vue?vue&type=script&lang=js&"
export * from "./MediumMediaSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\manla\\Downloads\\b\\public_html\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('69a79d1c')) {
      api.createRecord('69a79d1c', component.options)
    } else {
      api.reload('69a79d1c', component.options)
    }
    module.hot.accept("./MediumMediaSetting.vue?vue&type=template&id=69a79d1c&", function () {
      api.rerender('69a79d1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/admin/settings/MediumMediaSetting.vue"
export default component.exports